import { CellFormatOptions, ColumnTable, Table } from '@octano/global-ui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import SectionTitle from '../../../../../../../components/Text/SectionTitle';
import TableEmptyContent from '../../../../../../../components/Text/TableEmptyContent';
import { TranslationsKeys } from '../../../../../../../locales/translations';
import { formatDate } from '../../../../../../../utils/dates';
import { MainStudy } from '../../types';

interface MainStudiesProps {
  mainStudiesData: MainStudy[];
}

export const MainStudies = ({ mainStudiesData }: MainStudiesProps) => {
  const { t } = useTranslation(
    TranslationsKeys.STUDENT_FILE_EDUCATIONAL_BACKGROUND,
  );

  const texts = useMemo(() => {
    return {
      title: t(`title`),
      noRecords: t(`emptyContent.title`),
      noRecordsSubtitle: t(`emptyContent.subtitle`),
      columns: {
        academicLevel: t(`columns.academicLevel`),
        program: t(`columns.program`),
        description: t(`columns.description`),
        dateOfAcquisition: t(`columns.dateOfAcquisition`),
        action: t(`columns.action`),
      },
    };
  }, [t]);

  const columns = useMemo<ColumnTable<MainStudy>[]>(
    () => [
      {
        headerText: texts.columns.academicLevel,
        columnName: 'academicLevel',
        tdClassName: 'text-center',
        thClassName: 'text-center',
      },
      {
        headerText: texts.columns.program,
        columnName: 'program',
        thClassName: 'text-center',
        tdClassName: 'text-center',
      },
      {
        headerText: texts.columns.dateOfAcquisition,
        columnName: 'graduationDate',
        thClassName: 'text-center',
        tdClassName: 'text-center',
        cellFormat: (options: CellFormatOptions<MainStudy>) =>
          formatDate(options.row.graduationDate || '', 'DD/MM/YYYY'),
      },
    ],
    [texts],
  );

  return (
    <>
      <div className="w-100 mt-4">
        <SectionTitle text={texts.title} />
      </div>
      <div className="w-100 mt-4">
        <Table
          columns={columns}
          data={mainStudiesData}
          striped
          noResultsText={
            <TableEmptyContent
              title={texts.noRecords}
              subtitle={texts.noRecordsSubtitle}
            />
          }
        />
      </div>
    </>
  );
};
